import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import {manutencoesProgramadaModuleName} from "../../../manutencao-programada/shared/data.service";
import {manutencoesModuleName} from "../../../shared/data.service";
import {servicosModuleName} from "../../shared/data.service";
import {Servico, ServicoBem} from "../../shared/servico.model";
import {Frota} from "../../../../bens/frotas/shared/frota.model";
import {ManutencaoProgramadaNavigationService} from "../../../manutencao-programada/shared/manutencao-programada-navigation.service";
import {ServicoApiService} from "../../shared/servico-api.service";
import {ManutencaoProgramadaService} from "../../../manutencao-programada/shared/manutencao-programada.service";
import {UtilService} from "../../../../shared/services/util.service";
import {PlanoService} from "../../../planos/shared/plano.service";
import {OdometroHorimetroService} from "../../../odometros-horimetros/shared/odometro-horimetro.service";
import {FormaControleService} from "../../../../bens/formas-controle/shared/forma-controle.service";

@Component({
    template: require('./servico-bem-form.component.html'),
    styles: [require('./servico-bem-form.component.css')]
})
export class ServicoBemFormComponent implements OnInit {
    module: any = manutencoesModuleName;
    manutencaoProgramadaModule: any = manutencoesProgramadaModuleName;
    servicosModule: any = servicosModuleName;
    formObject: any = new ServicoBem();
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;

    frotaObject: Frota = new Frota();
    servicoObject: Servico = new Servico();
    periodicidadeTempoText: string;
    refTempo: any;

    form: FormGroup;
    periodicidadeOdometroHorimetro = new FormControl({value: '', disabled: true});
    periodicidadeTempo = new FormControl({value: '', disabled: true});
    servico = new FormControl({value: '', disabled: true});
    bem = new FormControl({value: '', disabled: true});
    proximaExecucaoOdometroHorimetro = new FormControl('');
    proximaExecucaoTempo = new FormControl('');

    constructor(
        private _route: ActivatedRoute,
        private _manutencaoProgramadaNavigationService: ManutencaoProgramadaNavigationService,
        private _servicoApiService: ServicoApiService,
        private _manutencaoProgramadaService: ManutencaoProgramadaService,
        private _planoService: PlanoService,
        private _utilService: UtilService,
        private _odometroHorimetroService: OdometroHorimetroService,
        private _formaControleService: FormaControleService,
        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            periodicidadeOdometroHorimetro: this.periodicidadeOdometroHorimetro,
            periodicidadeTempo: this.periodicidadeTempo,
            servico: this.servico,
            bem: this.bem,
            proximaExecucaoOdometroHorimetro: this.proximaExecucaoOdometroHorimetro,
            proximaExecucaoTempo: this.proximaExecucaoTempo
        });
    }

    ngOnInit() {
        let id = +this._route.snapshot.params['id'];
        this.getObject(id);
    }

    clickGoToList() {
        this._manutencaoProgramadaNavigationService.goToList();
    }

    clickCancel() {
        this._manutencaoProgramadaNavigationService.goToList();
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            var object:any = this._utilService.cloneObject(this.formObject);

            let date: any = document.getElementById('data');
            if (date.value) {
                date = this._utilService.convertStringToDate(date.value);
                date = new Date(date);
                date.setHours(8);
                date = +(date);
                object.proximaExecucaoTempo = date;
            }

            object.proximaExecucaoOdometroHorimetro = this._odometroHorimetroService.setMask(object.proximaExecucaoOdometroHorimetro);
            object.proximaExecucaoOdometroHorimetro = this._formaControleService.submitOdometroHorimetro(object.proximaExecucaoOdometroHorimetro);

            this.onEditServicoBem(object);
        }
    }

    private onEditServicoBem(object: ServicoBem) {
        this._servicoApiService.onPutServicoBem(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            this._utilService.swalMessageEditSuccess();

            this.clickGoToList();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhuma serviço encontrada com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._servicoApiService.onGetByIdServicoBem(id, onDone);
    }

    private setModelToForm() {
        if (this.formObject.bem) {
            this.frotaObject = this._utilService.cloneObject(this.formObject.bem);
            delete this.formObject['bem'];
        }

        if (this.formObject.servico) {
            this.servicoObject = this._utilService.cloneObject(this.formObject.servico);
            delete this.formObject['servico'];
        }

        if (this.formObject.periodicidadeTempo) {
            let t: any = this.formObject.periodicidadeTempo;
            t = t.toString();
            if (this.formObject.referenciaTempo) {
                this.refTempo = this._planoService.getReferenciaTempo(this.formObject.referenciaTempo);
                t = t.concat(" " + this.refTempo.Value);
                this.periodicidadeTempoText = t;
            }
        }

        if (this.formObject.proximaExecucaoTempo) {
            let t: any = this.formObject.proximaExecucaoTempo;
            this.formObject.proximaExecucaoTempoData = this._utilService.convertDateToString(t);
        }
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/servicos/servico-bens/servico-bem-form/servico-bem-form.component.ts
 **/